import { Box, Button, ButtonProps } from '@mui/material';
import Menu from '@mui/material/Menu';
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { IconChevronUp } from '@tabler/icons';
import { RefObject, useState } from 'react';

interface Props extends ButtonProps {
  isSelected?: boolean;
  subMenu?: any;
  disabled?: boolean;
  containerRef?: RefObject<HTMLDivElement> | null;
}

export default function ControlButton({ children, isSelected, subMenu, disabled, containerRef, ...props }: Props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <Button
      className={classes.root}
      {...props}
      sx={{
        background: isSelected ? '#337ab7' : 'rgba(51,51,51,.8)',
        border: 'none !important',
        flexDirection: 'column',
        minWidth: '100px !important',
        alignItems: 'center',
        '& > *': { marginRight: '0 !important', marginBottom: 0.5 }
      }}
      disabled={disabled}
    >
      {children}
      {subMenu && (
        <Box onClick={handleClick} style={{ position: 'absolute', top: 8, right: 20, cursor: 'pointer' }}>
          {!open ? <IconChevronUp size={20} color="#fff" /> : <IconChevronUp size={20} color="#fff" />}
        </Box>
      )}

      <Menu
        container={containerRef?.current}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        className={classes.menu}
      >
        {subMenu}
      </Menu>
    </Button>
  );
}

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '&.Mui-disabled': {
      backgroundColor: 'rgba(51,51,51,.8) !important',
      color: '#999 !important'
    }
  },
  menu: {
    '& .MuiPaper-root': {
      backgroundColor: 'rgba(60,60,60)',
      minHeight: 100
    }
  }
}));
